import Axios from "axios";
import request from "../utils/request";

export function getPublicOptions() {
    return request.get('/preDealer/public/options');
}

export function submitApplication(data: any) {
    return request.post('/preDealer/public', data);
}

export async function uploadPublicFile(file: File) {
    const response = await request.post('/preDealer/public/upload-url', {
        fileName: file.name,
        size: file.size,
        contentType: file.type,
    });
    const {key, url} = response.data.data;
    await Axios.put(url, file, {
        headers: {'Content-Type': file.type || 'application/octet-stream'}
    });
    return key;
}

export const getPreDealers = '/preDealer/';

export function getPreDealer(id: number) {
    return request.post('/preDealer/detail/query', null, {params: {id}});
}

export function convertToDealer(id: number, data: any) {
    return request.post('/preDealer/detail/convert', data, {params: {id}});
}
